(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("core"));
	else if(typeof define === 'function' && define.amd)
		define(["base", "core"], factory);
	else if(typeof exports === 'object')
		exports["module-content"] = factory(require("base"), require("core"));
	else
		root["module-content"] = factory(root["base"], root["core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(5);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(2);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../../.nvm/versions/node/v4.2.2/lib/node_modules/bb-lp-cli/node_modules/css-loader/index.js!./../../../../../../.nvm/versions/node/v4.2.2/lib/node_modules/bb-lp-cli/node_modules/less-loader/index.js!./base.less", function() {
				var newContent = require("!!./../../../../../../.nvm/versions/node/v4.2.2/lib/node_modules/bb-lp-cli/node_modules/css-loader/index.js!./../../../../../../.nvm/versions/node/v4.2.2/lib/node_modules/bb-lp-cli/node_modules/less-loader/index.js!./base.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports


	// module
	exports.push([module.id, ".lp-content-item{position:relative}.lp-empty-content-item:after,.lp-over-content-item:after{content:'Replace ' attr(data-type);min-height:98px;text-shadow:1px 1px 0 #fff;display:block;padding:30px;text-align:center;border:1px solid #ddd;text-transform:uppercase;font-weight:700;color:#999;background:#f0f0f0;position:absolute;top:0;bottom:0;left:0;right:0}.lp-over-content-item:after{position:absolute;background-color:#ddd;color:#fff;opacity:.9;text-shadow:-1px -1px 0 rgba(0,0,0,.5)}.lp-empty-content-item:after{content:'Drop ' attr(data-type) ' here'}", ""]);

	// exports


/***/ },
/* 3 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];

		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};

		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;

	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}

		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();

		var styles = listToStyles(list);
		addStylesToDom(styles, options);

		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}

	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}

	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}

	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}

	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}

	function addStyle(obj, options) {
		var styleElement, update, remove;

		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}

		update(obj);

		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}

	var replaceText = (function () {
		var textStore = [];

		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();

	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;

		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}

	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;

		if(media) {
			styleElement.setAttribute("media", media)
		}

		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}

	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;

		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}

		var blob = new Blob([css], { type: "text/css" });

		var oldSrc = linkElement.href;

		linkElement.href = URL.createObjectURL(blob);

		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {/**
	 *  ----------------------------------------------------------------
	 *  Copyright © Backbase B.V.
	 *  ----------------------------------------------------------------
	 *  Filename : main.js
	 *  Description: Main entry point
	 *  ----------------------------------------------------------------
	 */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    module.name = 'module-content';

	    var base = __webpack_require__(7);
	    var core = __webpack_require__(8);

	    var deps = [
	        core.name
	    ];

	    module.exports = base.createModule(module.name, deps)
	        // Utilities
	        .constant( __webpack_require__(9) )
	        // Provide with services collection
	        .provider( __webpack_require__(10) )
	        // Directives
	        .directive( __webpack_require__(12) );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)(module)))

/***/ },
/* 6 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* globals window */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var utils = __webpack_require__(7).utils;
	    var lpContentUtils = {
	        isEditable: function (widget) {

	            var bd = window.bd;

	            // Extend widget in design mode
	            if (bd && bd.designMode === 'true') {
	                var isMasterpage = utils.property('top.bd.PageMgmtTree.selectedLink.isMasterPage');

	                var isManageable = isMasterpage ||
	                    widget.model.manageable === 'true' ||
	                    widget.model.manageable === '' ||
	                    widget.model.manageable === undefined;

	                if (isManageable && bd && bd.bindDropEvents) {
	                    bd.bindDropEvents(widget.htmlNode);
	                    return true;
	                }
	            }
	            return false;
	        }
	    };

	   /**
	    * Export
	    */
	    exports.lpContentUtils = lpContentUtils;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    'use strict';

	    var API = __webpack_require__(11);

	    /**
	     * lpContent provider
	     * @return {object} angular provider
	     * @ngInject
	     */
	    exports.lpContent = function() {
	        var structuredContentEndpoint;

	        /**
	         * Set the endpoint to use for fetching server-side rendered structured content
	         */
	        this.setStructuredContentEndpoint = function (endpoint) {
	            structuredContentEndpoint = endpoint;
	        };

	        /**
	         * Configure the provider before initialisation.
	         * @ngInject
	         */
	        this.$get = function($http, lpWidget) {
	            return new API({
	                $http: $http,
	                uuid: lpWidget.model.uuid,
	                contextItemName: lpWidget.model.contextItemName,
	                structuredContentEndpoint: structuredContentEndpoint
	            });
	        };
	        this.$get.$inject = ["$http", "lpWidget"];

	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var utils = __webpack_require__(7).utils;
	    var cache = {};
	    var STRUCTURED_CONTENT_ENDPOINT = '$(contextRoot)/contenttemplates/rendered';

	    /**
	     * Services API
	     * @param  {object} config and DI to the API
	     */
	    var API = function(options) {
	        this.$http = options.$http;
	        this.config = {
	            uuid: options.uuid,
	            contextItemName: options.contextItemName,
	            structuredContentEndpoint: options.structuredContentEndpoint || STRUCTURED_CONTENT_ENDPOINT
	        };
	    };

	    utils.assign(API.prototype, {

	       /**
	        * get rendered content
	        * @param  {object} params get parameters
	        * @return {Promise} cached http promise
	        */
	        get: function(params) {

	            var endpoint = this.getConfig('structuredContentEndpoint');

	            var url = utils.resolvePortalPlaceholders(endpoint);

	            var urlParams = {
	                uuid: this.getConfig('uuid', true),
	                contextItemName: this.getConfig('contextItemName', true)
	            };

	            var key = [urlParams.uuid];

	            if (params && params.templateUrl) {
	                key.push(params.templateUrl[0]);
	                key.push(params.templateUrl[1]);
	                urlParams.templateUrl = params.templateUrl[1];
	            }

	            if (params && params.contentRef) {
	                key.push(params.contentRef[0]);
	                key.push(params.contentRef[1]);
	                urlParams['contentRef.contentRef'] = params.contentRef[1];
	            }


	            // Cache key: uuid_templateUrl_contentRef
	            key = key.join('_');


	            // Cache http promise
	            cache[key] = cache[key] || this.$http.get(url, {
	                params: urlParams,
	                headers: {
	                   'Accept': 'text/html'
	                }
	            }).then(function(data) {
	                return data;
	            });

	            return cache[key];
	        },

	        cleanCache: function() {
	            cache = {};
	        },

	        setConfig: function(options) {
	            this.config = utils(options).chain()
	                .mapValues(utils.resolvePortalPlaceholders)
	                .defaults(this.config)
	                .value();
	            return this;
	        },

	        getConfig: function(name, force) {
	            // return whole config if preference name was not passed
	            if (!name || !utils.isString(name)) {
	                return this.config;
	            }

	            if (force && utils.isUndefined(this.config[name])) {
	                throw new Error('lpContent is not configured with "' + name + '"');
	            }

	            return this.config[name];
	        }

	    });



	    module.exports = API;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    /**
	     * structured content directive
	     * attrs:
	     *     lp-content-item - (optional) content reference
	     *     template-url - (optional) template url
	     * event-listeners:
	     *     content.changed({ contentRef, templateUrl }) - Asynchronously replaces the content
	     * usage: <div lp-content-item="" template-url=""></div>
	     *        If the content-ref (via lp-content-item) or the template-url is provided, the contents
	     *        will be loaded asynchronously.
	     * @ngInject
	     */
	    exports.lpContentItemAsync = function ($compile, lpContent, lpContentUtils) {
	        var CONTENT_REF_ATTR = 'lpContentItemAsync';
	        var TEMPLATE_URL_ATTR = 'templateUrl';

	        var createParams = function (contentRef, templateUrl) {
	            var TEMPLATE_URL_PARAM = 'templateUrl';
	            var CONTENT_REF_PARAM = 'contentRef';

	            var params = {};

	            // directive uses custom template url preference
	            if (templateUrl) {
	                params[TEMPLATE_URL_PARAM] = [
	                    TEMPLATE_URL_PARAM,
	                    templateUrl
	                ];
	            }

	            // directive uses custom content reference preference
	            if (contentRef) {
	                params[CONTENT_REF_PARAM] = [
	                    CONTENT_REF_PARAM,
	                    contentRef
	                ];
	            }

	            return params;
	        };

	        var linkFn = function (scope, element, attrs) {
	            var render = function (contentRef, templateUrl) {
	                var params = createParams(contentRef, templateUrl);
	                return lpContent.get(params)
	                    .then(function (response) {
	                        var content = $compile(response && response.data)(scope);
	                        element.html(content);
	                    });
	            };

	            var init = function () {
	                var contentRef = attrs[CONTENT_REF_ATTR];
	                var templateUrl = attrs[TEMPLATE_URL_ATTR];

	                if (contentRef || templateUrl) {
	                    render(contentRef, templateUrl);
	                }
	            };

	            init();
	        };

	        return {
	            restrict: 'AE',
	            link: linkFn
	        };
	    };
	    exports.lpContentItemAsync.$inject = ["$compile", "lpContent", "lpContentUtils"];

	    /**
	     * structured content drag-n-drop directive
	     * attrs:
	     *     lp-content-item-picker - (optional) the initial content ref (probably from the widget preferences)
	     *     on-change - (optional) callback for changes in contentRef, provides `contentRef` in scope
	     * usage: <div lp-content-item-picker="{{contentRef}}" on-change="updateWidget(contentRef)"></div>
	     *        Does not asynchronously load content - if this is required, use lpContentItem.
	     * @ngInject
	     */
	    exports.lpContentItem = function ($compile, $parse, lpContent, lpContentUtils, lpWidget) {
	        var CONTENT_REF_ATTR = 'lpContentItem';

	        var ACTIVE_CLASS = 'lp-over-content-item';
	        var EMPTY_CLASS = 'lp-empty-content-item';

	        var CONTENT_SERVICES_PROTOCOL = 'cs';

	        var generateRef = function (item) {
	            return [CONTENT_SERVICES_PROTOCOL,
	                    item.repository === 'contentRepository' ? item.repository : '@portalRepository',
	                    item.contentUId
	                   ].join(':');
	        };

	        // init in the CXP manager
	        var initDesignMode = function (element, contentRef, contentRefChanged) {
	            var dragItem;

	            if (!contentRef) {
	                element.addClass(EMPTY_CLASS);
	            }

	            lpWidget.addEventListener('bdDrop.enter', function(e) {
	                var item = e.detail.info.helper.bdDragData.fileDataArray[0]; // e.detail.info.helper is a HTMLElement!@$#%

	                if (item.metaData && item.metaData['cmis:objectTypeId'] &&
	                    item.metaData['cmis:objectTypeId'].property === 'bb:structuredcontent') {
	                        dragItem = item;
	                        element.addClass(ACTIVE_CLASS);
	                } else {
	                    dragItem = undefined;
	                }
	            });

	            lpWidget.addEventListener('bdDrop.leave', function(e) {
	                element.removeClass(ACTIVE_CLASS);
	            });

	            // save contentRef preference on a widget
	            lpWidget.addEventListener('bdDrop.drop', function(e) {
	                if (!dragItem) {
	                    return;
	                }

	                var newRef = generateRef(dragItem);

	                dragItem = undefined;
	                element.removeClass(EMPTY_CLASS);
	                element.removeClass(ACTIVE_CLASS);

	                contentRefChanged(newRef);
	            });
	        };

	        var linkFn = function (scope, element, attrs) {
	            var contentRef = attrs[CONTENT_REF_ATTR];

	            var setContentRef = function (ref) {
	                if (!attrs.onChange) { return; }
	                $parse(attrs.onChange)(scope, { contentRef: ref });
	            };

	            // init in the CXP manager
	            if (lpContentUtils.isEditable(lpWidget)) {
	                initDesignMode(element, contentRef, setContentRef);
	            }
	        };

	        return {
	            restrict: 'AE',
	            link: linkFn
	        };
	    };
	    exports.lpContentItem.$inject = ["$compile", "$parse", "lpContent", "lpContentUtils", "lpWidget"];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** scripts/main.js
 **/